import React from 'react';

import styles from './Button.module.less';
import Button from '../../../../components/Button/Button';
import AButton from '../../../../components/AButton/AButton';

export default ({ soft = {}, className, size, logInfo = {} }) => {
  const classNames = [styles.Button, className, size].filter(o => o).join(' ');

  return soft.androidType === '1' ? (
    <AButton
      onClick={e => e.preventDefault()}
      soft={soft}
      info={{
        text: '安装',
        className: classNames,
        className_open: `${classNames} open`,
        className_busing: `${classNames} busy`,
        progressColor: '#F2FBF7',
        backgroundColor: '#FFFFFF',
      }}
      logInfo={logInfo}
    />
  ) : (
    <Button
      onClick={e => e.preventDefault()}
      soft={soft}
      info={{
        text: '安装',
        className: classNames,
        className_open: `${classNames} open`,
        className_busing: `${classNames} busy`,
        progressColor: '#F2FBF7',
        backgroundColor: '#FFFFFF',
      }}
      logInfo={logInfo}
    />
  );
};
